export const messages = {
    WFM_NO_ACTIONS: "No actions needed at this time",
    WFM_TERMINATED: "Nothing to do right now..",
    WFM_SOMETHING_WENT_WRONG: "Oops! An unexpected error occured. Kindly check your network connectivity or reload the page.",
    WFM_ACT_AS_USER_SAVE_AVAILABILTY_ERROR: "Changes cannot be saved when \"Acting as User\"",
    WFM_ACT_AS_USER_RISTRICT_ENV: "PROD",
};